import { useDeliveryStore } from "@/stores"
import { Truck, ShoppingBag, MapPin, ChevronDown } from "lucide-react"
import { useTranslation } from "react-i18next";

import { useUIStore } from "@/stores"

export const DeliveryStickyHeader = () => {
    const { t } = useTranslation();
    const { deliveryMethod, deliveryAddress } = useDeliveryStore()
    const { openModal } = useUIStore()

    if (!deliveryMethod) return null

    const getIcon = () => {
        switch (deliveryMethod) {
            case 'delivery': return <Truck className="w-5 h-5" />
            case 'pickup': return <ShoppingBag className="w-5 h-5" />
            case 'sushimat': return <MapPin className="w-5 h-5" />
            default: return null
        }
    }

    const getLabel = () => {
        switch (deliveryMethod) {
            case 'delivery': return 'Dostawa na adres'
            case 'pickup': return 'Odbiór Osobisty'
            case 'sushimat': return 'Odbiór w Sushimacie'
            default: return ''
        }
    }

    return (
        <>
            <div className="w-full border-t border-white/10 animate-in slide-in-from-top-2">
                <div className="container mx-auto px-4 h-12 lg:h-14 flex items-center justify-between md:justify-center gap-4 lg:gap-6">
                    <div className="flex items-center gap-2 lg:gap-3 text-sm md:text-base lg:text-lg">
                        <span className="text-gray-500 font-medium hidden md:inline lg:text-base">{t('Wybierz forme dostawy')}</span>
                        <div className="flex items-center gap-2 lg:gap-3 font-bold text-primary">
                            <span className="lg:hidden">{getIcon()}</span>
                            <span className="hidden lg:block">
                                {deliveryMethod === 'delivery' && <Truck className="w-6 h-6" />}
                                {deliveryMethod === 'pickup' && <ShoppingBag className="w-6 h-6" />}
                                {deliveryMethod === 'sushimat' && <MapPin className="w-6 h-6" />}
                            </span>
                            <span className="lg:text-xl">{getLabel()}</span>
                        </div>
                        {deliveryMethod === 'delivery' && deliveryAddress && (
                            <span className="text-gray-500 truncate max-w-[150px] md:max-w-xs lg:max-w-md border-l pl-2 lg:pl-4 border-gray-300 lg:text-base">
                                {deliveryAddress}
                            </span>
                        )}
                    </div>

                    {deliveryMethod === 'delivery' && !deliveryAddress ? (
                        <button
                            onClick={() => openModal('delivery-selection')}
                            className="text-xs lg:text-sm font-bold uppercase tracking-wider text-white bg-primary hover:bg-primary-hover px-4 lg:px-6 py-2 lg:py-2.5 rounded-full shadow-lg shadow-primary/30 transition-all flex items-center gap-2 animate-pulse"
                        >
                            <MapPin className="w-3 h-3 lg:w-4 lg:h-4" />
                            {t('ustalAdres')}</button>
                    ) : (
                        <button
                            onClick={() => openModal('delivery-selection')}
                            className="text-xs lg:text-sm font-bold uppercase tracking-wider text-gray-500 hover:text-primary transition-colors flex items-center gap-1 lg:gap-2 bg-gray-100 hover:bg-red-50 px-3 lg:px-5 py-1.5 lg:py-2 rounded-full"
                        >
                            {t('zmien')}<ChevronDown className="w-3 h-3 lg:w-4 lg:h-4" />
                        </button>
                    )}
                </div>
            </div>
        </>
    )
}
